import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allTechsLocs: [],
  certificates: [],
  technicians_list: [],
  address: null,
  addressTech: null,
  certificate: null,
  coordinates: {}
};

const dashboardSlice = createSlice({
  name: "techbsook",
  initialState,
  reducers: {
    setCertificates(state, action) {
      state.certificates = action?.payload;
    },
    setCertificate(state, action) {
      state.certificate = action?.payload;
    },
    setAddress(state, action) {
      state.address = action?.payload;
    },
    setCoordinates(state, action) {
      state.coordinates = action?.payload;
    },
    setTechniciansList(state, action) {
      state.technicians_list = action?.payload;
    },
    setAllTechsLocs(state, action) {
      state.allTechsLocs = action?.payload;
    },
    setAddressTech(state, action) {
      state.addressTech = action?.payload;
    },
  },
});

export const {
  setCertificates,
  setCertificate,
  setAddress,
  setAddressTech,
  setTechniciansList,
  setCoordinates,
  setAllTechsLocs,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
